<section class="playground">
  <h2 class="playground__heading">Area picture uploader — Gallery</h2>
  <p class="playground__hint">
    <code>common-area-picture-uploader-gallery</code> — contenedor multi-slot (hasta <code>maxSlots</code> fotos) con trigger de carga y slots vacíos decorativos. Usa <code>common-area-picture-uploader</code> para los slots llenos.
  </p>

  <div class="playground__grid">
    <div class="playground__controls">
      <label class="playground__field">
        <span>size</span>
        <select [(ngModel)]="size">
          <option *ngFor="let s of sizes" [value]="s">{{ s }}</option>
        </select>
      </label>

      <label class="playground__field">
        <span>maxSlots (total de slots)</span>
        <input type="number" [(ngModel)]="maxSlots" min="1" max="10" />
      </label>

      <label class="playground__field playground__field--checkbox">
        <input type="checkbox" [(ngModel)]="disabled" />
        <span>disabled</span>
      </label>

      <label class="playground__field">
        <span>URL de imagen (opcional, prueba manual)</span>
        <input type="text" [(ngModel)]="newImageUrl" placeholder="https://..." />
      </label>
      <button type="button" class="playground__btn-add-url" (click)="addImageUrl()">Añadir URL</button>

      <p class="playground__hint" style="font-size:12px; margin-top: 8px;">
        Clic en “Subir foto” abre el explorador; solo se aceptan imágenes. Puedes añadir también una URL de prueba arriba.
      </p>
    </div>

    <div class="playground__preview">
      <p class="playground__preview-title">Preview — {{ images.length }} de {{ maxSlots }} slots llenos</p>
      <div class="playground__preview-box">
        <common-area-picture-uploader-gallery
          [images]="images"
          [size]="size"
          [maxSlots]="maxSlots"
          [disabled]="disabled"
          (imagesChange)="onImagesChange($event)"
          (upload)="onUploadFiles($event)"
        ></common-area-picture-uploader-gallery>
      </div>

      <p *ngIf="lastEvent" class="playground__meta">{{ lastEvent }}</p>
    </div>
  </div>
</section>
